import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { TFunction } from "i18next";
import { TbCar } from "react-icons/tb";

import { TableHeader } from "@/components/TableHeader";
import { PlanFlightNumberCell } from "@/pages/Plannn/components/table/PlanLocationColumn";
import { IPlanPassenger } from "@/types/tasks.types";

const FlightNumberColumn = ({ t }: { t: TFunction }): GridColDef<IPlanPassenger<"api">> => {
    return {
        field: "flightNumber",
        headerName: t("flightNumber"),
        minWidth: 200,
        editable: false,
        renderHeader: (params) => <TableHeader Component={TbCar} title={params.colDef.headerName!} />,
        valueGetter: (_val, row) => row.flightNumber,
        renderCell: (params: GridRenderCellParams<IPlanPassenger<"api">>) => (
            <RenderCell value={params.row.flightNumber} />
        ),
    };
};

function RenderCell({ value }: { value: string }) {
    return (
        <div className="flex items-center h-full">
            <PlanFlightNumberCell value={value} colorized={true} />
        </div>
    );
}
export default FlightNumberColumn;
